import { VideoFrame } from './exportDesign'

export function downloadFile(file: File) {
  const link = document.createElement('a')
  const url = URL.createObjectURL(file)
  link.href = url
  link.download = file.name
  link.click()
  URL.revokeObjectURL(url)
}

export async function downloadVideo(video: VideoFrame, fileTitle?: string): Promise<File> {
  const response = await fetch(video.source_url)
  const blob = await response.blob()
  const frameName = video.frameId
  const fileType = video.source_url.split('.').pop() || 'mp4'
  const fileName = `${fileTitle || frameName}.${fileType}`

  return new File([blob], fileName)
}
